import React, { useState, useEffect } from "react";
import axios from "axios";
import "../styles/ParentRegister.css";

const ParentRegister = () => {
  const [email, setEmail] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [password, setPassword] = useState("");
  const [inviteCode, setInviteCode] = useState("");
  const [inviteCodeLocked, setInviteCodeLocked] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // ✅ Extract ?code= from URL on first render
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    if (code) {
      setInviteCode(code);
      setInviteCodeLocked(true); // Prevent manual editing
    }
  }, []);

  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    try {
      const response = await axios.post("/auth/register-parent", {
        email,
        password,
        display_name: displayName,
        invite_code: inviteCode,
      });

      localStorage.setItem("token", response.data.access_token);
      setSuccess("Account created! Redirecting...");

      setTimeout(() => {
        window.location.href = "/view-photos";
      }, 2000);
    } catch (err) {
      const detail =
        err.response?.data?.detail || "Something went wrong. Please try again.";
      setError(detail);
    }
  };

  return (
    <div className="parent-register-container">
      <h2>Create Your Parent Account</h2>
      <form onSubmit={handleRegister} className="parent-register-form">
        <input
          type="email"
          placeholder="Your Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <input
          type="text"
          placeholder="Display Name"
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
          required
        />

        <input
          type="password"
          placeholder="Create Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <input
          type="text"
          placeholder="Invite Code"
          value={inviteCode}
          onChange={(e) => setInviteCode(e.target.value)}
          disabled={inviteCodeLocked}
          required
        />

        <button type="submit">Register</button>
      </form>

      {error && <p className="error-text">{error}</p>}
      {success && <p className="success-text">{success}</p>}
    </div>
  );
};

export default ParentRegister;
